import "./MetroLogo.scss";

import React from "react";
import { withReactAdapter } from "shared/src/module-federation/withReactAdapter";

type Props = {
    country: string;
};

export function MetroLogo(props: Props) {
    const className = "metro-logo-container text-center";
    return (
        <div className={className}>
            <span className="metro-logo" lang={props.country} />
        </div>
    );
}

export default withReactAdapter(MetroLogo);
